import { CardSubtitle } from "../../types/CoreComponents";
import { WorldPositions } from "../../types/General";
import { StyleItem, WorldMapItems } from "../../types/Miscellaneous";

export const ContainerStyle: StyleItem = {
  height: "500px",
};

export const DefaultCenter: WorldPositions = {
  lat: -3.745,
  lng: -38.523,
};

export const WorldMapSubheading: CardSubtitle[] = [
  {
    text: "Below Map is displaying the world map.",
  },
];

export const UsaMapSubHeading: CardSubtitle[] = [
  {
    text: "Below Map is displaying the USA map.",
  },
];
export const IndiaMapSubHeading: CardSubtitle[] = [
  {
    text: "Below Map is displaying the India map.",
  },
];

export const AustraliaMapSubHeading: CardSubtitle[] = [
  {
    text: "Below Map is displaying the Australia map.",
  },
];

const WorldPosition: WorldPositions = { lat: 50, lng: 10 };
const UsaPosition: WorldPositions = { lat: 37.0902, lng: -95.7129 };
const IndiaPosition: WorldPositions = { lat: 20.5937, lng: 78.9629 };

export const WorldMapProps: WorldMapItems = {
  center: WorldPosition,
  zoom: 2,
  maxZoom: 10,
  attributionControl: true,
  zoomControl: true,
  doubleClickZoom: true,
  scrollWheelZoom: true,
  dragging: true,
  easeLinearity: 0.35,
};

export const UsaMapProps: WorldMapItems = {
  center: UsaPosition,
  zoom: 4,
  minZoom: 2,
  maxZoom: 10,
};

export const IndiaMapProps: WorldMapItems = {
  center: IndiaPosition,
  zoom: 5,
};

export const CenterAustralia: WorldPositions = { lat: -25.2744, lng: 130.7751 };

export const AustraliaMapProps: WorldMapItems = {
  center: CenterAustralia,
  zoom: 4,
  zoomControl: true,
  doubleClickZoom: true,
  scrollWheelZoom: true,
  dragging: true,
};
